/** Transient panel messages. Institutional tone, no exclamation marks. */

const LIFETIME_MS = 6000;

let root: HTMLElement | null = null;

export function initToasts(mount: HTMLElement): void {
  root = mount;
}

export function toast(message: string): void {
  if (root === null) return;

  const node = document.createElement('div');
  node.className = 'toast';
  node.textContent = message;
  root.append(node);

  globalThis.setTimeout(() => node.remove(), LIFETIME_MS);
}
